import { Component } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-ops',
  templateUrl: './ops.component.html',
  standalone: false,
  styleUrls: ['./ops.component.scss']
})
export class OpsComponent {

  opsData: any;
  barChartSettings = {
    showXAxis: true,
    showYAxis: true,
    gradient: true,
    showLegend: false,
    showXAxisLabel: true,
    xAxisLabel: 'Country',
    showYAxisLabel: true,
    yAxisLabel: 'Count',
    data: [],
  };

  kycPendingData: any;

  kycPendingPieChartSettings = {
    doughnut: true,
    gradient: true,
    showLabels: true,
    legend: false
  }

  colorScheme: Color = {
    name: "custom",
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      "#0d30da", "#ff7043", "#00bcd4", "#5e35b1", "#66bb6a"
    ],
  };

  constructor(private _apiService: ApiService) {

  }

  ngOnInit() {
    const vm = this;
    vm.getOpsData();
  }

  getOpsData() {
    const vm = this;
    vm._apiService.postData('/dashboard/customer-status', {}).subscribe((res: any) => {
      if (res && !res.error) {
        vm.opsData = res.data.stats;
        vm.barChartSettings.data = res.data.data.map((item: any) => ({
          name: item.name,
          value: item.value
        }));
        vm.kycPendingData = res.data.KYCPending.map((item: any) => ({
          name: item.name,
          value: item.value
        }));
      }
    });
  }

}
